// src/frontend_react/src/components/userDashboard/TrustAndSecurityCard.js
import React from 'react';

import Card from '../ui/Card/Card';
import Typography from '../ui/Typography/Typography';
import Stack, { HStack } from '../ui/Stack/Stack';
import Icon from '../ui/Icon/Icon';
import Box from '../ui/Box/Box';

import { FiHash, FiLock, FiShield, FiTrash2, FiZap } from 'react-icons/fi';
import styles from './TrustAndSecurityCard.module.css';

const TrustAndSecurityCard = ({ manifest }) => {
  if (!manifest) return null;

  const securityPoints = [
    {
      icon: FiHash,
      title: 'Original File Hash (SHA-256):',
      description: manifest.original_file_hash,
      isCode: true,
    },
    {
      icon: FiHash,
      title: 'Deidentified Data Hash (SHA-256, pre-encryption):',
      description: manifest.file_metadata?.processed_file_content_hash,
      isCode: true,
    },
    {
      icon: FiZap,
      title: 'Ephemeral Hashing Key:',
      description:
        'The key used for HMAC hashing was temporary and derived from a short-lived, signed token. It is not stored and has now been discarded.',
    },
    {
      icon: FiLock,
      title: 'Encryption:',
      description: `The deidentified data has been encrypted locally on your machine using AES-256 encryption. The final encrypted file is: ${manifest.encrypted_filename_on_disk}`,
    },
    {
      icon: FiShield,
      title: 'PII Removal:',
      description:
        'The PII columns you identified, including the original Identifier Column, have been excluded from the deidentified dataset before encryption.',
    },
    ...(manifest.raw_file_deleted_from_client_confirmed
      ? [
          {
            icon: FiTrash2,
            title: 'Local Raw File Copy:',
            description:
              "You confirmed the secure deletion of the app's temporary working copy of the raw PII file from this machine.",
          },
        ]
      : []),
  ];

  return (
    <Card
      title="Data Integrity & Security Confirmation"
      titleIcon={<Icon as={FiShield} />}
    >
      <Stack p="md" spacing="lg">
        <Typography color="secondary">
          To ensure transparency and data integrity, please note the following
          details about the process:
        </Typography>
        <Stack spacing="md" className={styles.detailsList}>
          {securityPoints.map(
            (point) =>
              point.description && (
                <HStack key={point.title} spacing="md" alignItems="flex-start">
                  <Icon
                    as={point.icon}
                    color="secondary"
                    size="lg"
                    style={{ marginTop: '4px' }}
                  />
                  <Stack spacing="xs" style={{ flexGrow: 1 }}>
                    <Typography fontWeight="semibold">{point.title}</Typography>
                    {point.isCode ? (
                      <Typography component="code" className={styles.codeValue}>
                        {point.description}
                      </Typography>
                    ) : (
                      <Typography variant="body2" color="secondary">
                        {point.description}
                      </Typography>
                    )}
                  </Stack>
                </HStack>
              ),
          )}
        </Stack>
      </Stack>
    </Card>
  );
};

export default TrustAndSecurityCard;
